import { module } from 'modujs'
import { html } from '../utils/environment'
import config from '../config'
import SurveyMixin from '../utils/vue/mixins/SurveyMixin'
import Background from '../utils/vue/components/Background'
import { GtagHandler } from '../app'


export default class SurveyControl extends module {

    static get settings() {
        return {
            data: {
                fr: {
                    answers: [
                        'Pas du tout probable',
                        'Un peu probable',
                        'Assez probable',
                        'Très probable',
                    ]
                },
                en: {
                    answers: [
                        'Unlikely',
                        'Slightly likely',
                        'Moderately Likely',
                        'Very likely',
                    ]
                }
            },
            answersValue: [
                0,
                5,
                40,
                55,
            ],
        }
    }

    constructor(m) {
        super(m)

        // DOM
        this.$el = this.el
    }

    init() {
        GtagHandler.emit('surveyStartControl')

        html.setAttribute('data-survey-control-valid', 'false')

        const backUrl = this.$el.dataset.backUrl
        const introLsq = this.$el.dataset.introLsq

        const moduleUrls = JSON.parse(this.$el.dataset.urls)
        const apiURL = moduleUrls.questions
        const resultsURL = moduleUrls.results

        const that = this

        const answers = SurveyControl.settings.data[config.LANG].answers.map((a, i) => ({
            label: a,
            value: SurveyControl.settings.answersValue[i]
        }))

        this.app = new Vue({
            el: this.$el,
            mixins: [ SurveyMixin ],
            components: {
                Background,
            },
            data: {
                apiURL,
                answers,
                currentAnswerIndex: 0,
                modalIsOpen: false,
                showModalButton: false,
            },
            updated() {
                this.$nextTick(() => {
                    that.call('update', null, 'Scroll')
                })
            },
            mounted() {
                const introSplit = new SplitText(this.$refs.intro, {
                    type: 'words,chars'
                })

                this.introSplit = introSplit.chars

                const modalSupSplit = new SplitText(this.$refs.modalSup, {
                    type: 'words,chars'
                })

                this.modalSupSplit = modalSupSplit.chars

                window.addEventListener('resize', this.onResize = () => this.resize())
            },
            computed: {
                lsqSrc() {
                    return this.modalIsOpen ? this.currentQuestion?.a11yVideoQuestion?.fr : this.currentQuestion?.a11yVideoResult?.fr
                },
            },
            methods: {
                onComplete() {
                    this.gtagEmitDuration()
                    sessionStorage.setItem('surveyControlResults', JSON.stringify(this.questions))
                    html.setAttribute('data-survey-control-valid','true')
                    that.call('goto', resultsURL ,'Load')
                },
                onBack() {
                    this.gtagEmitDuration()
                    this.showModalButton = false
                    that.call('goto', backUrl, 'Load')
                },
                onBeforeSetCurrentQuestion() {
                    this.showModalButton = false

                    return new Promise(resolve => {

                        if(!this.firstAnimation) {

                            gsap.to(this.$refs.transition, {
                                opacity: 1,
                                duration: 0.3,
                                ease: 'power2.out',
                                onComplete: () => {
                                    resolve()
                                }
                            })
                        } else {
                            resolve()
                        }
                    })
                },
                onSetCurrentQuestion() {

                    // Time tracker for gtag
                    this.gtagEmitDuration()
                    this.timer = new Date

                    // this.time = new Date()

                    this.$nextTick(() => {

                        // Modal Question Split
                        const modalQuestionSplit = new SplitText(this.$refs.modalQuestion, {
                            type: 'words,chars'
                        })

                        this.modalQuestionSplit = modalQuestionSplit.chars


                        if (this.firstAnimation) {
                            this.animate(1.3)
                            this.firstAnimation = false
                        } else {
                            this.closeModal(0)
                            this.animate(0.4)

                            // Reset scroll
                            that.call('scrollTo', { target: '#main', options: { duration: 0 }}, 'Scroll')
                            this.$refs.modalInner.scrollTop = 0

                            gsap.to(this.$refs.transition, {
                                opacity: 0,
                                duration: 0.3,
                                ease: 'power2.out',
                            })

                            if (this.currentQuestion.answer) {
                                this.currentAnswerIndex = Math.max(SurveyControl.settings.answersValue.findIndex(a => '' + a == this.currentQuestion.answer), 0)
                            }
                        }
                    })
                },
                openModal() {
                    this.modalIsOpen = true

                    html.classList.add('has-modal-open')

                    const tl = gsap.timeline({
                        defaults: {
                            ease: 'none'
                        }
                    })

                    tl
                        .set(this.modalQuestionSplit, {
                            opacity: 0.2
                        })
                        .to(this.$refs.modal, {
                            yPercent: -100,
                            duration: 0.3,
                            ease: 'power2.out',
                        })
                        .fromTo(this.modalSupSplit,
                            {
                                opacity: 0,
                            },
                            {
                                duration: 0.3,
                                opacity: 1,
                                stagger: 0.02,
                            },
                        '-=0.4')
                        .to(this.modalQuestionSplit, {
                            duration: 0.3,
                            opacity: 1,
                            ease: 'none',
                            stagger: 0.02,
                        }, '-=0.2')
                },
                closeModal(duration=0.4) {
                    this.modalIsOpen = false

                    html.classList.remove('has-modal-open')

                    gsap.to(this.$refs.modal, {
                        yPercent: 0,
                        duration,
                        ease: 'power2.out',
                        onComplete: () => {
                            gsap.set(this.$refs.modal, { clearProps: 'all' })
                        }
                    })
                },
                replay() {
                    this.closeModal()
                    this.animate(0.4, false)
                },
                animate(delay=0.2, split=true) {

                    if(split) {
                        // Context animation
                        const contextSplit = new SplitText(this.$refs.context, {
                            type: 'words,chars'
                        })

                        this.contextSplit = contextSplit.chars
                    } else {
                        this.tl.kill()
                    }

                    this.tl = gsap.timeline({
                        defaults: {
                            ease: 'none'
                        },
                    })

                    this.tl
                        .fromTo(this.introSplit,
                            {
                                opacity: 0
                            },
                            {
                                duration: 0.3,
                                opacity: 1,
                                delay,
                                ease: 'none',
                                stagger: 0.02,
                            },
                        0)
                        .fromTo(this.contextSplit,
                            {
                                opacity: 0,
                            },
                            {
                                opacity: 0.2,
                                delay,
                                ease: 'sine.out',
                                duration: 0.3
                            },
                        0)
                        .to(this.contextSplit, {
                            duration: 0.3,
                            opacity: 1,
                            ease: 'none',
                            stagger: 0.02,
                        }, '-=0.2')
                        .add(() => {
                            this.showModalButton = true
                        }, '<0.2')
                },
                resize() {
                    if(this.modalIsOpen) {
                        this.closeModal()
                    }
                },
                gtagEmitDuration() {
                    if(this.timer) {
                        const duration = new Date - this.timer
                        GtagHandler.emit('surveyControlQuestionDuration', {
                            value: duration
                        })
                    }
                }
            },
            unmounted() {
                window.removeEventListener('resize', this.onResize)
            }
        })
    }

    destroy() {
        this.app?.$destroy()
    }
}

